import { useMutation } from "@tanstack/react-query";
import {
  CanBeAreaMembersManagerRequest,
  CanBeAreaMembersManagerResponse,
  checkCanBeAreaMembersManager,
} from "src/Pages/Company/OrganizationStructure/api";

const useCheckCanBeAreaMembersManager = (
  companyId: string,
  employeeId: string
) =>
  useMutation<
    CanBeAreaMembersManagerResponse,
    Error,
    CanBeAreaMembersManagerRequest
  >({
    mutationFn: async (payload: CanBeAreaMembersManagerRequest) =>
      checkCanBeAreaMembersManager(companyId, employeeId, payload),
  });

export default useCheckCanBeAreaMembersManager;
